import createAction from 'loankeeper-common/helpers/createAction'

import { actionTypes } from './constants'

export const initialize = (args) => createAction(actionTypes.INITIALIZE, args)
export const storeUpdatesInRedux = (args) => createAction(actionTypes.STORE_UPDATES, args)
export const setPanelMode = ({ mode }) => createAction(actionTypes.SET_PANEL_MODE, { mode })
export const fetchReports = (args) => createAction(actionTypes.FETCH_REPORTS, args)
export const changeStatus = (status) => createAction(actionTypes.CHANGE_STATUS, { status })
export const checkReportsStatus = (modalParams) => createAction(actionTypes.CHECK_REPORTS_STATUS, modalParams, {})
export const cancelStatusCheck = () => createAction(actionTypes.CANCEL_CHECK)
export const generatedReportsFetched = (data, id) => createAction(actionTypes.GENERATED_REPORTS_FETCHED, data, id)
// export const getGeneratedExcel = (ident, stk) => createAction(actionTypes.GET_EXCEL_FILE, ident, stk)
export const close = () => createAction(actionTypes.CLOSE)
